import {
  selectIsAppFeatureLimited,
  selectPartnerIsWelshLocale
} from '../stores/partner';

const helpLoader = async ({ getState }) => {
  const storeState = getState();
  const isAppFeatureLimited = selectIsAppFeatureLimited(storeState);
  const isWelsh = selectPartnerIsWelshLocale(storeState);

  if (!isAppFeatureLimited && !isWelsh) {
    throw new Response('Not Found', { status: 404 });
  }

  return null;
};

export default helpLoader;
